<template>
  <div class="physical-chemical-title">
    <flex-table-title
      :class="{ 'physical-chemical-title__custom-not-alarmed': isNotAlarmedAndCustomized }"
      :title="$t(`enums.engineering.physical-chemical.norms.${norm.norm}`)"
      :sub-name="subName"
      :has-alarms="hasAlarms"
    />
    <span
      v-if="showCustomNameBelow"
      data-test="custom-name-below"
      class="font-weight-normal"
    >
      {{ norm.name }}
    </span>
  </div>
</template>

<script>
import FlexTableTitle from '../FlexTableTitle';

export default {
  name: 'PhysicalChemicalFlexTableTitle',
  components: {
    FlexTableTitle,
  },
  props: {
    norm: {
      type: Object,
      required: true,
    },
    showCustomNameBelow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isNotAlarmedAndCustomized() {
      return this.norm.custom && !this.hasAlarms;
    },
    subName() {
      return this.norm.custom && !this.showCustomNameBelow ? this.norm.name : '';
    },
    alarmedFields() {
      return (this.norm || {}).alarmedFields || [];
    },
    hasAlarms() {
      return this.alarmedFields.length > 0;
    },
  },
};
</script>

<style lang="sass" scoped>
  .physical-chemical-title
    text-align: center
    &__custom-not-alarmed
      ::v-deep .flex-table-title__text
        color: var(--color-success)
</style>
